import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var XIcon20Light = forwardRefAndName('XIcon20Light', function (props, ref) {
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    ref: ref,
    viewBoxSize: 20
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.146 4.146a.5.5 0 0 1 .708 0L10 9.293l5.146-5.147a.5.5 0 1 1 .707.708L10.707 10l5.146 5.146a.5.5 0 1 1-.707.707L10 10.707l-5.146 5.146a.5.5 0 1 1-.708-.707L9.293 10 4.146 4.854a.5.5 0 0 1 0-.708Z"
  }));
});